/* cp-drawer.js — menu mobile
   - le panneau est sorti de l'en-tete : celle-ci cree un cadre de reference
     pour les elements fixes, le menu ouvert apres avoir defile la page se
     retrouvait hors ecran
   - navigation a deux niveaux, comme une appli
   - chaque bloc du niveau 2 devient une RANGEE qui defile
   - vignettes en haute definition (les sources du menu sont en 64 px)
   - dans Maillots : championnats, clubs, maillots, ensembles enfant */
(function(){
  var b = document.getElementById('cpBurger');
  var d = document.getElementById('cpDrawer');
  if(!b || !d) return;
  var hd = document.getElementById('hd');

  /* sortir le panneau de l'en-tete (sinon position:fixed se cale sur elle) */
  if(d.parentElement !== document.body) document.body.appendChild(d);

  var inner = d.querySelector('.cpdin') || d;

  function place(){
    var y = hd ? Math.max(0, Math.round(hd.getBoundingClientRect().bottom)) : 0;
    d.style.setProperty('--cpd-top', y + 'px');
  }

  /* ---------- 1. vignettes nettes + type de rangee ---------- */
  function upgrade(){
    var lists = inner.querySelectorAll('.cpd2l');
    for(var i=0;i<lists.length;i++){
      var list = lists[i];
      if(list.dataset.cpRow) continue;
      var links = list.children, boot = 0, crest = 0, plain = 0;
      for(var j=0;j<links.length;j++){
        var a = links[j];
        var cst = a.querySelector('.cst');
        if(!cst){ a.classList.add('is-plain'); plain++; continue; }
        var img = cst.querySelector('img');
        if(img && img.getAttribute('src')){
          var s = img.getAttribute('src');
          s = s.replace(/width=64\b/, 'width=220').replace(/width=170\b/, 'width=560');
          img.setAttribute('src', s);
          img.removeAttribute('width');
          img.removeAttribute('height');
        }
        if(cst.classList.contains('wide')){ a.classList.add('is-boot'); boot++; }
        else { a.classList.add('is-crest'); crest++; }
      }
      var kind = 'plain';
      if(boot >= crest && boot >= plain && boot > 0) kind = 'boot';
      else if(crest >= plain && crest > 0) kind = 'crest';
      list.classList.add('row-' + kind);
      list.dataset.cpRow = kind;
    }
  }

  /* ---------- 2. blocs supplementaires dans Maillots ---------- */
  function block(titleTxt, href, cls){
    var c = document.createElement('div');
    c.className = 'cpd2c';
    var h = document.createElement('a');
    h.className = 'cpd2h';
    h.href = href || '#';
    h.textContent = titleTxt;
    var l = document.createElement('div');
    l.className = 'cpd2l ' + cls;
    l.dataset.cpRow = 'done';
    c.appendChild(h); c.appendChild(l);
    return { box: c, list: l };
  }

  function crestRow(data, limit){
    var frag = document.createDocumentFragment();
    for(var i=0; i<data.length && i<limit; i++){
      var x = data[i];
      if(!x || !x.img) continue;
      var a = document.createElement('a');
      a.href = x.u || '#';
      a.className = 'is-crest';
      a.innerHTML = '<span class="cst"><img loading="lazy" src="' + x.img + '" alt=""></span>';
      a.appendChild(document.createTextNode(x.n || ''));
      frag.appendChild(a);
    }
    return frag;
  }

  function card(p){
    var im = (p.images && p.images[0]) ? p.images[0].src : '';
    if(!im) return null;
    var pr = (p.variants && p.variants[0]) ? p.variants[0].price : '';
    var a = document.createElement('a');
    a.href = '/products/' + p.handle;
    a.innerHTML =
      '<span class="im"><img loading="lazy" src="' + im.replace(/(\.[a-z]+)(\?|$)/i, '_400x$1$2') + '" alt=""></span>' +
      '<span class="t"></span><span class="p"></span>';
    a.querySelector('.t').textContent = (p.title || '')
      .replace(/^Maillot\s+/i, '')
      .replace(/^Kit\s+Enfant\s+/i, '')
      .replace(/\s+\d{4}\/\d{4}$/, '');
    a.querySelector('.p').textContent = pr ? String(pr).replace('.', ',') + ' €' : '';
    return a;
  }

  function prodRow(list, url, limit, keep){
    fetch(url + '/products.json?limit=40', {headers:{'Accept':'application/json'}})
      .then(function(r){ return r.ok ? r.json() : null; })
      .then(function(j){
        if(!j || !j.products) return;
        function fill(filter){
          var n = 0;
          for(var i=0;i<j.products.length && n<limit;i++){
            var p = j.products[i];
            if(filter && !filter.test(p.title || '')) continue;
            var a = card(p);
            if(!a) continue;
            list.appendChild(a);
            n++;
          }
          return n;
        }
        if(fill(keep) === 0 && keep) fill(null);
      })
      .catch(function(){});
  }

  function enrichMaillots(){
    var dets = inner.querySelectorAll('details.cpd1w');
    var target = null;
    for(var i=0;i<dets.length;i++){
      var s = dets[i].querySelector('summary.cpd1');
      if(s && /maillots/i.test((s.textContent||'').trim())){ target = dets[i]; break; }
    }
    if(!target) return;
    var box = target.querySelector('.cpd2');
    if(!box || box.dataset.cpRich) return;
    box.dataset.cpRich = '1';

    function read(id){ var e=document.getElementById(id); try{ return e?JSON.parse(e.textContent):[] }catch(x){ return [] } }
    var ligues = read('cp-ligues2');
    var clubs  = read('cp-clubs2');

    if(clubs.length){
      var bc = block('Par club', '/collections/maillots-de-football', 'row-crest');
      bc.list.appendChild(crestRow(clubs, 14));
      box.insertBefore(bc.box, box.firstChild);
    }
    if(ligues.length){
      var bl = block('Par championnat', '/collections/maillots-de-football', 'row-crest');
      bl.list.appendChild(crestRow(ligues, 8));
      box.insertBefore(bl.box, box.firstChild);
    }

    var all = box.querySelector('.cpd2all');
    var bm = block('Les maillots', '/collections/maillots-de-football', 'row-prod');
    box.insertBefore(bm.box, all);
    prodRow(bm.list, '/collections/maillots-de-football', 10, /maillot/i);

    var be = block('Ensembles enfant', '/collections/maillots-enfant', 'row-prod');
    box.insertBefore(be.box, all);
    prodRow(be.list, '/collections/maillots-enfant', 10, null);
  }

  /* ---------- 3. deux niveaux ---------- */
  var back = document.createElement('button');
  back.type = 'button';
  back.className = 'cpd-back';
  back.innerHTML = '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="m15 5-7 7 7 7"/></svg><span>Retour</span>';

  var title = document.createElement('div');
  title.className = 'cpd-title';

  inner.insertBefore(title, inner.firstChild);
  inner.insertBefore(back, inner.firstChild);

  function level1(){
    d.classList.remove('lvl2');
    var act = inner.querySelectorAll('.cpd1w.act');
    for(var i=0;i<act.length;i++){ act[i].classList.remove('act'); act[i].open = false; }
    d.scrollTop = 0;
  }
  back.addEventListener('click', level1);

  var dets2 = inner.querySelectorAll('details.cpd1w');
  for(var k=0;k<dets2.length;k++){
    (function(det){
      var sum = det.querySelector('summary.cpd1');
      if(!sum) return;
      sum.addEventListener('click', function(e){
        e.preventDefault();
        var act = inner.querySelectorAll('.cpd1w.act');
        for(var j=0;j<act.length;j++){ act[j].classList.remove('act'); act[j].open = false; }
        det.open = true;
        det.classList.add('act');
        title.textContent = (sum.textContent || '').trim();
        d.classList.add('lvl2');
        d.scrollTop = 0;
      });
    })(dets2[k]);
  }

  /* ---------- 4. raccourcis en bas du panneau ---------- */
  function close(){
    if(d.hidden) return;
    d.hidden = true;
    b.setAttribute('aria-expanded', 'false');
    document.body.classList.remove('cpd-open');
    level1();
  }

  /* Aucune carte d'offre ici : l'offre volume n'est plus affichee sur le site. */
  var oldPromo = inner.querySelector('.cpd-promo');
  if(oldPromo) oldPromo.remove();

  if(!inner.querySelector('.cpd-foot')){
    var f = document.createElement('div');
    f.className = 'cpd-foot';
    var sb = document.createElement('button');
    sb.type = 'button'; sb.className = 'cpd-f'; sb.textContent = 'Rechercher';
    sb.addEventListener('click', function(){
      close();
      var dlg = document.getElementById('cpSearch');
      if(dlg && dlg.showModal) dlg.showModal();
    });
    var a1 = document.createElement('a'); a1.className='cpd-f'; a1.href='/account'; a1.textContent='Mon compte';
    var a2 = document.createElement('a'); a2.className='cpd-f'; a2.href='/cart'; a2.textContent='Panier';
    f.appendChild(sb); f.appendChild(a1); f.appendChild(a2);
    inner.appendChild(f);
  }

  /* ---------- 5. ouverture / fermeture ---------- */
  b.addEventListener('click', function(){
    setTimeout(function(){ place(); if(d.hidden) level1(); }, 0);
  });
  window.addEventListener('resize', function(){ if(!d.hidden) place(); }, {passive:true});
  window.addEventListener('orientationchange', function(){ if(!d.hidden) setTimeout(place, 250); });
  document.addEventListener('keydown', function(e){ if(e.key === 'Escape') close(); });

  enrichMaillots();
  upgrade();
  place();
})();
